import { useCallback, useEffect, useState } from 'react';
import { getFilterOptions } from '../services/filterOptions';

export function useFilterOptions(categoryId, enabled = true) {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOptions = useCallback(async () => {
    if (!enabled || !categoryId) {
      setSubjects([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await getFilterOptions({ categoryId });
      setSubjects(res?.data?.subjects || []);
    } catch (e) {
      setError(e?.message || 'Failed to load subjects');
      setSubjects([]);
    } finally {
      setLoading(false);
    }
  }, [categoryId, enabled]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return { subjects, loading, error, refetch: fetchOptions };
}
